'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _backCloseHeader = require('./backCloseHeader.scss');

var _backCloseHeader2 = _interopRequireDefault(_backCloseHeader);

var _shape = require('-!svg-react-loader!../../../assets/images/change-provider/shape.svg');

var _shape2 = _interopRequireDefault(_shape);

var _ChooseProviderCloseButton = require('./ChooseProviderCloseButton');

var _ChooseProviderCloseButton2 = _interopRequireDefault(_ChooseProviderCloseButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BackCloseHeader = function BackCloseHeader(props) {
  var onClose = props.onClose,
      onBack = props.onBack,
      t = props.t;

  var backButton = onBack ? _react2.default.createElement(
    'div',
    { onClick: onBack, className: _backCloseHeader2.default.back },
    (0, _shape2.default)({ width: '6', height: '8', viewBox: '0 0 6 8' }),
    _react2.default.createElement(
      'span',
      { className: _backCloseHeader2.default.backText },
      t.getByKey('ChangeProvider_Switch_Screen_Back')
    )
  ) : _react2.default.createElement('div', null);
  return _react2.default.createElement(
    'div',
    { className: _backCloseHeader2.default.container },
    backButton,
    _react2.default.createElement(_ChooseProviderCloseButton2.default, { onClick: onClose })
  );
};

BackCloseHeader.propTypes = {
  onClose: _propTypes2.default.func,
  onBack: _propTypes2.default.func,
  t: _propTypes2.default.object
};

exports.default = BackCloseHeader;